export enum ADDRESS_TYPE {
  HOME = 'home',
  MAIL = 'mail'
}
